module.exports = __webpack_public_path__ + "static/media/Download.970296f4.svg";